import * as React from "react";
import { forwardRef } from "react";
const CloseIcon = ({
  title,
  titleId,
  ...props
}, ref) => /*#__PURE__*/React.createElement("svg", Object.assign({
  xmlns: "http://www.w3.org/2000/svg",
  "aria-hidden": "true",
  viewBox: "0 0 20 20",
  fill: "currentColor",
  "data-category": "actions",
  ref: ref,
  "aria-labelledby": titleId
}, props), title ? /*#__PURE__*/React.createElement("title", {
  id: titleId
}, title) : null, /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  d: "m12.3566 10 7.1547-7.1547c.6516-.65164.6516-1.70493 0-2.35657-.6517-.65164-1.705-.65164-2.3566 0L10 7.64343 2.8453.48873c-.65164-.65164-1.70493-.65164-2.35657 0s-.65164 1.70493 0 2.35657L7.64343 10l-7.1547 7.1547c-.65164.6516-.65164 1.7049 0 2.3566.324986.325.75163.4883 1.17828.4883s.8533-.1633 1.17829-.4883L10 12.3566l7.1547 7.1547c.325.325.7516.4883 1.1783.4883.4266 0 .8533-.1633 1.1783-.4883.6516-.6517.6516-1.705 0-2.3566z",
  clipRule: "evenodd"
}));
const ForwardRef = forwardRef(CloseIcon);
ForwardRef.category = "actions";
export { ForwardRef as CloseIcon };